import { useContext } from "react";
import { ITabBarsProps } from "../../types";
import cx from "classix";
import { Context } from "../ChatPanel/ChatContext";
import TabBarItem from "./TabBarItem";

export default function TabBars({ tabs, tab, setTab, context }: ITabBarsProps) {
	const tabsNumber = tabs.length

	return (
		<div className="flex flex-row justify-end gap-1 bg-neutral-20 p-1 rounded-lg w-full">
			{tabsNumber > 0 && tabs.map(t => <TabBarItem key={t.key} tab={t} activeTab={tab} setTab={setTab} context={context} />)}
		</div>
	);
}
